import type { EnglishIntensity } from '@orborix/shared-types';
import type { EnglishState } from '../../lib/englishApi.js';

/**
 * Intensidad con la que corre (o va a correr) la sesión — espejo de
 * `resolveInitialIntensity` del runtime de languages: bajo overlay de
 * exploración el backend IGNORA el hint del cliente y usa la intensidad
 * efectiva del `/state` (`effectiveIntensityOf`: la del nivel explorado, o la
 * fijada a mano); sin overlay rige la de esta charla (`settings.intensity`:
 * escena o global). Un cambio en vivo bajo overlay pasa por
 * `level.setIntensity`/`setLevelAuto`, que actualizan ambas → no divergen.
 *
 * Es la que decide si estilo y tono están bloqueados (`isConvStyleLocked`): lo
 * que la UI muestra bloqueado tiene que ser lo que el backend aplica.
 */
export function sessionIntensity(
  settingsIntensity: EnglishIntensity,
  levelState: Pick<EnglishState, 'levelOverlay' | 'effectiveIntensity'> | null,
): EnglishIntensity {
  return levelState?.levelOverlay ? levelState.effectiveIntensity : settingsIntensity;
}
